import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixGrid {
  static init(...parameters) {
    return new BrixGrid(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-grid', BrixGrid.init);
}
